var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sparkline-wrapper"},[_c('div',{staticClass:"sparkline-inner"},[_c('canvas',{ref:"chart",staticStyle:{"height":"100%","width":"100%"}}),(_vm.speeds.length)?_c('div',{staticClass:"label"},[_vm._v(" Max: "+_vm._s(_vm.maxSpeed.toFixed(1))+" km/h ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }